import {
  Directive,
  HostListener,
  HostBinding,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { FIleType } from '../../Models/fileTypes';
import { FilesService } from '../Pages/files/files-api.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { FolderInfo } from 'src/app/Models/FolderInfo';

@Directive({
    selector: '[fileDragDrop]',
    standalone: false
})
export class FileDragNDropDirective {
  //@Input() private allowed_extensions : Array<string> = ['png', 'jpg', 'bmp'];
  @Output() private filesChangeEmiter: EventEmitter<File[]> =
    new EventEmitter();
    @Input() IsProfileProfile:any;
    @Input() accept = ['.jpeg', '.jpg', '.png','.JPEG', '.JPG', '.PNG', '.mp4', '.MP4'];
  //@Output() private filesInvalidEmiter : EventEmitter<File[]> = new EventEmitter();
  @HostBinding('style.background') background = '';
  @HostBinding('style.border') borderStyle = '';
  @HostBinding('style.border-color') borderColor = '';
  @HostBinding('style.border-radius') borderRadius = '';

  constructor(private notify: NotificationService,private fileService: FilesService) {}

  @HostListener('dragover', ['$event']) public onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    if (this.isValidFolder()) {
      this.background = 'lightgray !important';
      this.borderColor = 'cadetblue !important';
      this.borderStyle = '2px dashed';
    }
  }
  private isValidFolder = () =>
    this.fileService.currentFolderInfo &&
    this.fileService.currentFolderInfo.id &&
    this.fileService.currentFolderInfo.acceptType != FIleType.UserSpecific;
  private emptyStyle() {
    this.background = '';
    this.borderColor = '';
    this.borderStyle = '';
  }
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.emptyStyle();
  }

  @HostListener('drop', ['$event']) public onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    if (this.isValidFolder() || this.IsProfileProfile) {
      this.emptyStyle();
      let files = evt.dataTransfer.files;
      const valid_files: File[] = Array.from(files);      
      if((this.fileService.currentFolderInfo?.parentId ? this.fileService.currentFolderInfo?.parentId.toUpperCase() : this.fileService.currentFolderInfo?.id.toUpperCase()) == FolderInfo.Photo && !valid_files.map(i=>i.name.toLowerCase()).every(i=>this.accept.some(a=>i.endsWith(a.toLowerCase())))){
        this.notify.showError(
          'Please choose suggested file types : '+ this.accept.join(',')
        );
        return;
      }else if(this.IsProfileProfile && !valid_files.map(i=>i.name.toLowerCase()).every(i=>this.accept.some(a=>i.endsWith(a.toLowerCase()))))
      {
        this.accept = ['.jpeg', '.jpg', '.png','.JPEG', '.JPG', '.PNG'];
        this.notify.showError(
          'Please choose suggested file types : '+ this.accept.join(',')
        );
        return;
      }
      this.filesChangeEmiter.emit(valid_files);
    }
  }
}
